/* unplugin-vue-components disabled */import { render } from "./MainTitle.vue?vue&type=template&id=d788da50&scoped=true&ts=true"
import script from "./MainTitle.vue?vue&type=script&lang=ts"
export * from "./MainTitle.vue?vue&type=script&lang=ts"

import "./MainTitle.vue?vue&type=style&index=0&id=d788da50&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d788da50"]])

export default __exports__